import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEmployeeAuthStore, useUIStore } from '../stores';
import './Employee.css';

function EmployeeLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { login, isLoading, error } = useEmployeeAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (isLoading) {
      return; // Prevent multiple submissions
    }

    try {
      // Use Zustand employee auth store for authentication
      await login({
        username: username.trim(),
        password: password
      });

      // If no error is thrown, login succeeded
      useUIStore.getState().showSuccessNotification('Login successful! Welcome to your employee portal.');
      
      // Small delay to ensure Zustand state propagates to all subscribers
      setTimeout(() => {
        navigate('/employee/dashboard', { replace: true });
      }, 100);
      
    } catch (error) {
      // Error is already handled by the store, but we can show a notification
      useUIStore.getState().showErrorNotification(error.message || 'Login failed. Please try again.');
    }
  };

  return (
    <div className="employee-login-container">
      <div className="employee-login-card">
        <h2>Employee Login</h2>
        <p className="employee-login-subtitle">Seemanchal Decor Employee Portal</p>
        <form onSubmit={handleSubmit} className="employee-login-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button 
            type="submit" 
            className="employee-login-button"
            disabled={isLoading || !username.trim() || !password}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        {isLoading && (
          <div className="employee-login-loading">
            <p>Authenticating with server...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmployeeLogin;

